import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';

export interface ArtistTabSearchListCSSStyle extends UIComponentCSSStyle
{

}

export class  ArtistTabSearchListCSSStyleImpl extends UIComponentCSSStyleImpl implements ArtistTabSearchListCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            width:"100%",
            display:'flex',
            flexDirection:'row',
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/artist/artistsearchlistcss.tsx